export default __webpack_public_path__ + "static/media/rakesh.a17bd4ea.png";